import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import { ToastContainer } from "react-toastify";
import {
  DeleteManageWorkAction,
  GetAllManageWorkAction,
} from "../../../../redux/actions/ManageWorkAction";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import fileDownload from "js-file-download";
import notify from "../../../Notifcation";
import Pagination from "../../../Utility/Pagination/Pagination";
const Display = ({
  setKey,
  Datee,
  setDatee,
  ManageWorkID,
  setManageWorkID,
  Requirework,
  setRequirework,
  GehaWork,
  setGehaWork,
  MenueWork,
  setMenueWork,
  Result,
  setResult,
  Notes,
  setNotes,
  SelectedFile,
  setSelectedFile,
  Description,
  setDescription,
  IsEdit,
  setIsEdit,
  Eye,
  setEye,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const PageSize = 7;
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setManageWorkID(itemid);
  };
  const onPress = async (page) => {
    await dispatch(
      GetAllManageWorkAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteManageWorkAction(ManageWorkID));
    setLoading(false);
    setManageWorkID("");
    setshowDelete(false);
    setIsPress(false);
    setDatee("");
    setManageWorkID("");
    setRequirework("");
    setGehaWork("");
    setMenueWork("");
    setResult("");
    setNotes("");
    setSelectedFile("");
    setDescription("");
    setIsPress(false);
    setLoading(false);
  };
  const Update = (item) => {
    setKey("money");
    setRequirework(item.WantedWork || "");
    setResult(item.Result || "");
    setNotes(item.Note || "");
    setManageWorkID(item.Id);
    setSelectedFile(item.FileUrl);
    setDescription(item.FileDescription === null ? "" : item.FileDescription);
    setMenueWork(item.EmployeeName || "");
    setGehaWork(item.Destination || "");
    setDatee(item.Date);

    setIsEdit(true);
    setEye(false);
  };
  const HandleShow = (item) => {
    setKey("money");

    setRequirework(item.WantedWork || "");
    setResult(item.Result || "");
    setNotes(item.Note || "");
    setManageWorkID(item.Id);
    setSelectedFile(item.FileUrl);
    setDescription(item.FileDescription === null ? "" : item.FileDescription);
    setMenueWork(item.EmployeeName || "");
    setGehaWork(item.Destination || "");
    setDatee(item.Date);
    setIsEdit(false);
    setEye(true);
  };
  const ALL = useSelector((state) => state.ManageWorkR.GetManagework);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllManageWorkAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  }, [Searchkey, Dateeto, Dateefrom]);
  const handleSubmit = async () => {
    await dispatch(
      GetAllManageWorkAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  };
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const DEL = useSelector((state) => state.ManageWorkR.DeleteManagework);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage ===
              "Great, admin management deleted Successfully"
          ) {
            dispatch(GetAllManageWorkAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                العمل المطلوب<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                جهة العمل <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                النتيجة<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.Data && ALL.Data.length > 0
              ? ALL.Data.map((item, idx) => (
                  <tr key={idx} onDoubleClick={() => Update(item)}>
                    <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                    <td>{item.WantedWork}</td>
                    <td>{item.Destination}</td>
                    <td>{item.Result}</td>
                    <td>
                      {" "}
                      {item.FileUrl !== null ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleShowpopup(item.FileUrl)}>
                            {" "}
                            <i className="fa-solid fa-paperclip"></i>
                          </button>
                          <span>{item.FileDescription}</span>
                        </>
                      ) : (
                        " "
                      )}
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => Update(item)}
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleShow(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={ALL ? ALL.TotalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        {/* <button className="buttonadd">تصدير</button> */}
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer autoClose={1200} />
      </div>
    </>
  );
};
export default Display;
